import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f27c49e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "stats",
  ref: "stats"
}
const _hoisted_2 = {
  id: "minutes",
  ref: "minutes"
}
const _hoisted_3 = { class: "stats-number" }
const _hoisted_4 = { class: "small" }
const _hoisted_5 = { class: "tag" }
const _hoisted_6 = {
  id: "channels",
  ref: "channels"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Your Top Channels ", -1))
const _hoisted_8 = { class: "channels" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Channel"),
    /*#__PURE__*/_createElementVNode("th", null, "Videos"),
    /*#__PURE__*/_createElementVNode("th", null, "Minutes")
  ])
], -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = { id: "hidden" }
const _hoisted_12 = {
  id: "canvas",
  ref: "canvas",
  width: "500",
  height: "500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, [
        _createTextVNode(" You have watched "),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.videosWatchedDisplay), 1),
        _createTextVNode(" videos in " + _toDisplayString(_ctx.year) + " 🎉 ", 1)
      ]),
      _createElementVNode("h3", null, [
        _createTextVNode(" That's "),
        _createElementVNode("span", null, _toDisplayString(_ctx.minutes), 1),
        _createTextVNode(" minutes of YouTube! ")
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode("Top tags: "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mostTags?.map(({tag}) => tag), (tag, i) => {
          return (_openBlock(), _createElementBlock("span", {
            id: "tags",
            key: i
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(tag), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.topChannels && _ctx.topChannels(...args)))
      }, "View your top channels 👉")
    ], 512),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", null, [
          _hoisted_9,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mostWatched, (channel, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: channel.url,
                    target: "_blank"
                  }, _toDisplayString(channel.name), 9, _hoisted_10)
                ]),
                _createElementVNode("td", null, _toDisplayString(channel.videos), 1),
                _createElementVNode("td", null, _toDisplayString(channel.minutes), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.genImage && _ctx.genImage(...args)))
      }, "Download 🔗")
    ], 512),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("canvas", _hoisted_12, null, 512)
    ])
  ], 512))
}